"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.createNoopAuthFacade = exports.createAuthFacade = exports.KeepAlive = exports.LocalStorageSessionRefreshTimer = exports.AuthApi = exports.UserService = exports.WindowNavigator = exports.StorageObject = exports.LocalStorageSession = exports.LegacySessionAPI = exports.authenticateAxios = void 0;
var authService_1 = require("./authService");
Object.defineProperty(exports, "authenticateAxios", { enumerable: true, get: function () { return authService_1.authenticateAxios; } });
var legacySessionAPI_1 = require("./legacySessionAPI");
Object.defineProperty(exports, "LegacySessionAPI", { enumerable: true, get: function () { return legacySessionAPI_1.LegacySessionAPI; } });
var sessionService_1 = require("./sessionService");
Object.defineProperty(exports, "LocalStorageSession", { enumerable: true, get: function () { return sessionService_1.LocalStorageSession; } });
var storageObject_1 = __importDefault(require("./storageObject"));
exports.StorageObject = storageObject_1.default;
var windowNavigator_1 = __importDefault(require("./windowNavigator"));
exports.WindowNavigator = windowNavigator_1.default;
var userService_1 = __importDefault(require("./userService"));
exports.UserService = userService_1.default;
var authApi_1 = require("./authApi");
Object.defineProperty(exports, "AuthApi", { enumerable: true, get: function () { return authApi_1.AuthApi; } });
var localStorageSessionRefreshTimer_1 = require("./localStorageSessionRefreshTimer");
Object.defineProperty(exports, "LocalStorageSessionRefreshTimer", { enumerable: true, get: function () { return localStorageSessionRefreshTimer_1.LocalStorageSessionRefreshTimer; } });
var keepAlive_1 = require("./keepAlive");
Object.defineProperty(exports, "KeepAlive", { enumerable: true, get: function () { return keepAlive_1.KeepAlive; } });
var authFacade_1 = require("./authFacade");
Object.defineProperty(exports, "createAuthFacade", { enumerable: true, get: function () { return authFacade_1.createAuthFacade; } });
Object.defineProperty(exports, "createNoopAuthFacade", { enumerable: true, get: function () { return authFacade_1.createNoopAuthFacade; } });
var BadRequestError_1 = __importDefault(require("./errors/BadRequestError"));
var ServerError_1 = __importDefault(require("./errors/ServerError"));
var UnexpectedError_1 = __importDefault(require("./errors/UnexpectedError"));
var UnauthorizedError_1 = __importDefault(require("./errors/UnauthorizedError"));
var Errors = {
    BadRequestError: BadRequestError_1.default,
    ServerError: ServerError_1.default,
    UnexpectedError: UnexpectedError_1.default,
    UnauthorizedError: UnauthorizedError_1.default,
};
exports.Errors = Errors;
//# sourceMappingURL=index.js.map